const translations = {
    'resource.bricks': 'cegły',
    'resource.charcoal': 'węgiel drzewny',
    'resource.clothRope': 'tkanina/lina',
    'resource.coins': 'monety',
    'resource.fiber': 'włókno',
    'resource.fish': 'ryby',
    'resource.food': 'żywność',
    'resource.gold': 'złoto',
    'resource.goldOre': 'ruda złota',
    'resource.ironIngots': 'sztabki żelaza',
    'resource.ironOre': 'ruda żelaza',
    'resource.leather': 'skóra',
    'resource.planks': 'deski',
    'resource.stone': 'kamień',
    'resource.tools': 'narzędzia',
    'resource.trees': 'drzewa',
    'resource.weapons': 'broń',
    'resource.wild_life': 'dzika zwierzyna',
    'resource.wood': 'drewno',
};

export default translations;
